export const CONSTANTS = {
  SCREEN_GROUP: 'auth',
  LIST_ALL: 'list-auth-all',
  REQUEST_AUTH_LOGON: 'request-auth-logon',
  REQUEST_AUTH_LOGOFF: 'request-auth-logoff',
  REQUEST_AUTH_UPDATE_SESSION: 'request-auth-update-session',
  REQUEST_AUTH_CHANGE_FACILITY: 'request-auth-change-facility',
  REQUEST_AUTH_CHANGE_CUSTOMER: 'request-auth-change-customer',
  REQUEST_AUTH_CHANGE_LANGUAGE: 'request-auth-change-language',
  REQUEST_AUTH_CHANGE_THEME: 'request-auth-change-theme',
  REQUEST_AUTH_GET_PERMISSIONS: 'request-auth-get-permissions',
  REQUEST_PING: 'auth-ping',
  DIALOG_TIMEOUT: 'dialog-timeout',
} as const;
